import {
  greaterThan,
  integer,
  lessThan,
  maxLength,
  multipleOf,
  predicate,
  required
} from "@libs/validation/fieldValidators.ts";
import { Validator } from "@libs/validation/Validator.ts";

import { AppointmentTypeFormValues } from "./AppointmentTypeForm.types.ts";

export class AppointmentTypeFormValidator extends Validator<AppointmentTypeFormValues> {
  constructor(options: {
    groupAppsAllowed: boolean;
    stepValidated: boolean;
    step: number;
  }) {
    super();

    const { groupAppsAllowed, stepValidated, step } = options;

    this.forField("name", [required(), maxLength(255)]);
    this.forField("duration", [
      required(),
      integer(),
      greaterThan(0),
      lessThan(1440)
    ]);

    if (stepValidated) {
      this.forField("duration", [multipleOf(step)]);
    }
    if (groupAppsAllowed) {
      this.forField("maxParticipants", [
        required(),
        integer(),
        greaterThan(0),
        lessThan(1001)
      ]);
    }

    this.forField(
      "commsSchedules",
      predicate((value, values) => !!values?.linkToSchedule, required())
    );
  }
}
